
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/[book]",
      function () {
        return require("private-next-pages/books/[book]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/[book]"])
      });
    }
  